import { Box, SkeletonText, SvgIcon, Tooltip } from '@volue/wave-react';
import React from 'react';

import { useTenantState } from '../hooks/useTenantState.hook';

export function Organization() {
  const { isSelected, organizationName } = useTenantState();

  return (
    <Box className="sidebarNav-headerMenu" css={{ color: '$colorAccent25' }}>
      <Tooltip
        content={`Organization: ${organizationName}`}
        placement="top"
        className="parentZIndex1100"
      >
        <div className="dF aiC pAs ofH">
          <span className="sidebarNav-headerTopLogo mRm mLs dF">
            <SvgIcon size="small" iconName="building" />
          </span>
          <SkeletonText
            width="20ch"
            css={{
              background: '$colorPrimary60'
            }}
            className="pRs mLs txtTruncate"
            isLoaded={isSelected}
          >
            <span>{organizationName}</span>
          </SkeletonText>
        </div>
      </Tooltip>
    </Box>
  );
}
